import React, {Component} from 'react';
import {Link} from 'react-router-dom';

export default class PrivacyPolicy extends Component {

    render() {
        return (
            <div className="page terms-of-service">
                <div className="page_contents">
                    <h1>Privacy Policy</h1>
                    <div className="card">
                        <div style={{textAlign: 'right'}}><em>Last updated on May 31, 2017</em></div>
                        <br/>

                        <p>This Privacy Policy is designed to provide clarity about the information we collect and how we use it to provide a better
                            experience using the
                            "Deep Contrast" online service, sometimes alternately known as the "Image Pop" service (the "Service"). Deep Contrast,
                            Inc. and service providers
                            acting on its behalf ("DCI" and "we" or "us") is the provider of the Service. By accepting this Privacy Policy and the
                            {' '}<Link to="/terms-of-service">Terms of Service</Link>{' '} when registering or installing the Service, you consent to
                            our
                            collection, storage,
                            use and disclosure of your personal information as described in this Privacy Policy.
                        </p>

                        <p>This Privacy Policy describes:</p>

                        <p>
                            <ul>
                                <li>The information that we collect, how we collect it, and the purposes of our collection</li>
                                <li>How we use and with whom we share this information</li>
                                <li>How we protect the information we store about you</li>
                            </ul>
                        </p>

                        <p>If you access the Service from a third party site, you may be required to read and accept the third party's own terms of
                            service and privacy
                            policy in addition to our Terms of Service and this Privacy Policy. If you have questions regarding this Privacy Policy or
                            our collection and use
                            of information, please contact us as described in the section below entitled "How to Contact Us".
                        </p>

                        <h4>1) Information We Collect</h4>

                        <p>When you use the Service, you may provide to DCI, or allow DCI to access, certain information from your profile. For
                            example, DCI may collect the
                            following information, as allowed by you:
                        </p>

                        <p>
                            <ul>
                                <li>your name</li>
                                <li>your profile picture or its URL</li>
                                <li>your physical location</li>
                                <li>your gender</li>
                                <li>your age range</li>
                                <li>photographs that you submit to the site</li>
                                <li>information about any manual editing made to original and processed images</li>
                            </ul>
                        </p>

                        <p>By using the Service, you authorize DCI to collect, store, and use in accordance with this Privacy Policy any and all
                            information that you provide.
                        </p>

                        <p>When you access the Service, we may collect (i) certain technical information about your computer or device, including IP
                            Address and device ID;
                            and (ii) usage statistics about your interactions with the Service. We also collect information about your play and
                            interaction with other users
                            of the Service.
                        </p>

                        <p>You may be able to take part in certain activities in our Service that give you the opportunity to communicate or share
                            information not just with
                            DCI, but also with other users of our Service. These activities currently include such features as the opportunity to
                            create and share canvases of
                            curated content, and to submit comments and multimedia on other users' canvases.
                        </p>

                        <p>To protect the safety and well being of our users and DCI's rights, we may record and store archives of these
                            communications on DCI's
                            servers and the servers of any web hosting providers that DCI uses. You acknowledge and consent to the recording and
                            storage of such
                            communications for these purposes.
                        </p>

                        <h4>2) How We Use the Information We Collect</h4>

                        <p>We collect certain technical information in order to (i) analyze the usage of our sites and services; (ii) provide a more
                            personalized experience;
                            (iii) support educational research; and (iv) manage potential sponsorship or advertising.
                        </p>

                        <p>We collect, store, and use your information to provide you with a safe, smooth, efficient, and customized experience. For
                            example, we may use your
                            information to:
                        </p>

                        <p>
                            <ul>
                                <li>Create your account and profile with the Service</li>
                                <li>Identify and suggest connections with other users of the Service and with content located on the Service
                                </li>
                                <li>Identify and suggest that you see content located on the Service</li>
                                <li>Enable user-to-user communications</li>
                                <li>Provide technical support or respond to user inquiries</li>
                                <li>Prevent fraud or potentially illegal activities, and enforce our Terms of Service</li>
                                <li>Deliver and target advertising</li>
                                <li>Notify users of Service feature updates</li>
                                <li>Solicit input and feedback to improve the quality of the Service and to customize your user experience
                                </li>
                                <li>Inform users about new products, content, or promotional offers</li>
                                <li>Engage in commonly accepted practices, such as contacting you at the email address that we have on file
                                </li>
                            </ul>
                        </p>

                        <p>We and any service providers acting on our behalf, such as Google Analytics, use log files and tracking technologies to
                            collect and analyze certain
                            types of technical information, including cookies, IP addresses, device type, device identifiers, browser types, browser
                            language, referring and
                            exit pages, and URLs, platform type, the number of clicks, domain names, landing pages, pages viewed and the order of
                            those pages, the amount of
                            time spent on particular pages, usage state and the date and time of activity on our websites, and other similar
                            information. In some cases, we
                            may associate this information with your user ID number for our internal use. We may also employ other technologies for
                            tracking and analyzing
                            user behavior.
                        </p>

                        <p>One important use of your information is communication. If you have provided your e-mail address to DCI, we may use it to
                            respond to (i) customer
                            support inquiries, and (ii) keep you informed of your activity in the Service, including notifications about content
                            status or comments from other
                            users. Some messages, such as invitations to and from users (so as to invite others to collaborate using the Service) may
                            include your name and
                            profile photo. We may also send promotional e-mail messages ("Promotional Communications") directly or in partnership with
                            parties other
                            than DCI. Each Promotional Communication will generally offer recipients choices about receiving additional messages.
                        </p>

                        <h4>3) Sharing of Your Information</h4>

                        <p>Under certain circumstances, we will share information about you and other users of the Service with third parties (that is
                            to say, parties other
                            than DCI). We will never intentionally share personally identifiable information about you, except as required by law. We
                            may share information
                            that is not specifically identifiable to you, such as anonymized or aggregated information of users of the Service.
                            Nothing in this Privacy Policy
                            will restrict DCI's collection, use, or disclosure of anonymous or aggregated information.
                        </p>

                        <p>If DCI collects and stores personally identifiable information on any servers owned by the web hosting providers that DCI
                            uses, then for the
                            purposes of this Privacy Policy, the information that DCI maintains on these servers will be deemed held by DCI and not
                            shared with other parties.
                        </p>

                        <p>We will share your information (in some cases personal information about you, but never personally identifiable information
                            about you) with third
                            parties in the following circumstances:
                        </p>

                        <p>Educational Research</p>

                        <p>In providing the Service, one of DCI's goals is to conduct academic research into social networking, the emergence and
                            availability of
                            public, private, and crowdsourced knowledge, and the process of education, including formal and informal learning. As part
                            of our academic
                            mission, we may publish papers, articles, and books; and we may give lectures and make other presentations summarizing our
                            research and our
                            findings. These publications will never include personally identifiable information about any individual user of the
                            Service, unless a user
                            publishes personally identifiable information meant for eventual discovery by other users of the Service.
                        </p>

                        <p>Third Party Service Providers</p>

                        <p>We may provide your information to third party companies to perform services on our behalf. These services may include data
                            analysis, e-mail
                            delivery, hosting services, payment processing, customer service, and to assist in marketing efforts. We direct all such
                            third party service
                            providers to maintain the confidentiality of the information disclosed to them and to not use your information for any
                            purpose other than to
                            provide services on DCI's behalf.
                        </p>

                        <p>Friends and Other Consumers of the Service</p>

                        <p>The Service supports and may encourage interaction among individual users of the Service. In the Service, your Facebook
                            friends will see your name,
                            profile photo and descriptions of your activities using the Service. Also, your friends and other consumers of the service
                            will be able to see
                            your profile, which may include your name and your profile photo.
                        </p>

                        <p>Advertising of Third Party Products and Services</p>

                        <p>We do not currently share your personal information with third party advertisers for their direct marketing purposes. If we
                            do eventually enable
                            such direct marketing advertising in the future, then we will update this Privacy Policy to specifically cover such
                            activities.
                        </p>

                        <p>Safety, Security and Compliance with Law</p>

                        <p>Your information, and the contents of all of your online communications (including without limitation comments, video and
                            multimedia content, chat
                            text, voice communications, IP addresses and any other personal information) may be accessed and monitored as necessary to
                            provide the Service and
                            may be disclosed: (i) when we have a good faith belief that we are required to disclose the information in response to
                            legal process (for example,
                            a court order, search warrant or subpoena); (ii) to satisfy any applicable laws or regulations; (iii) where we believe
                            that the Service is being
                            used in the commission of a crime, including to report such criminal activity or to exchange information with other
                            companies, organizations, or
                            individuals for the purposes of fraud protection and credit risk reduction; (iv) when we have a good faith belief that
                            there is an emergency that
                            poses a threat to the health and/or safety of you, another person or the public generally; and (v) in order to protect the
                            rights or property of
                            DCI, including to enforce our Terms of Service.
                        </p>

                        <p>Sale or New Venture</p>

                        <p>In the event that DCI transfers the Service as part of a business transition, such as a license or sale of all or a portion
                            of the Service's
                            core assets, we may transfer all of your information, including personal information, to the acquiring entity. If material
                            changes to the Service's
                            privacy practices will occur as a result of the business transition, we will notify you and other users (in the manner
                            described below in the
                            section entitled "Changes to Our Privacy Policy") of the business transition prior to transferring your personal
                            information.
                        </p>

                        <h4>4) Our Policies Concerning Children</h4>

                        <p>The Service is not intended for children under the age of 13 and we do not knowingly collect any personal information from
                            children. Children under
                            the age of 13 should not use the Service at any time. In the event that we learn that we have inadvertently gathered
                            personal information from
                            children under the age of 13, we will take reasonable measures to erase such information from our records.
                        </p>

                        <h4>5) How to Access and Update Your Information</h4>

                        <p>To manage the information DCI receives about you, you will need to log in to the Service and click on the thumbnail image
                            that appears in the upper
                            right hand corner of the page. You may need to delete and recreate any canvases that contain any personal information that
                            you submitted there.
                        </p>

                        <p>How to Deactivate Your Service Account</p>

                        <p>Your account will be considered active until we receive a request to delete or deactivate it.</p>

                        <p>If you no longer want DCI to make active use of your information, you may send an e-mail message as follows to <a
                            href="mailto:privacy@deepcontrast.com">privacy@deepcontrast.com</a>: Place "Delete My Account" in the subject line of your
                            message;
                            and in the body of your message, include your name, your e-mail address, and the user name that you provide when you log
                            in to the Service.
                        </p>

                        <p>We will use reasonable efforts to respond to your request in a timely way. Please note that while we may deactivate your
                            account, certain records
                            will be retained for legal, accounting, and general Service quality purposes. For example, if you have sent or posted
                            content on the Service (such
                            as comments, images, videos, other multimedia files, or canvases that were subsequently remixed), we may not entirely
                            delete all of the content
                            that you submitted.
                        </p>

                        <h4>6) Privacy Policies of Linked Sites</h4>

                        <p>Our Service may contain advertisements or linked content from companies other than DCI. We are not responsible for the
                            privacy practices these
                            other companies. If you have any questions about how these other websites use your information, you should review their
                            policies and contact them
                            directly.
                        </p>

                        <h4>7) Security of Your Information</h4>

                        <p>DCI implements reasonable security measures to protect the security of your information both online and offline, and we are
                            committed to the
                            protection of customer information.
                        </p>

                        <p>While we do take precautions against possible security breaches of our servers and our customer databases and records, no
                            Internet server or
                            transmission is completely secure. We cannot guarantee that unauthorized access, hacking, data loss, or other breaches
                            will never occur. Further,
                            if your own computer or third party accounts are hacked, this may lead to unauthorized use of the Service using your
                            Service account, so be
                            careful to keep your information secure.
                        </p>

                        <p>Unfortunately, as mentioned above, the transmission of information over the Internet is not completely secure. Although we
                            strive to protect your
                            personal data, we cannot guarantee the security of your data while it is transmitted to and from our site; any
                            transmission is at your own risk.
                            Once we have received your information, we have procedures and security features in place to try to prevent unauthorized
                            access.
                        </p>

                        <h4>8) Changes to our Privacy Policy</h4>

                        <p>If we decide to make material changes to this Privacy Policy, we will notify you and other users by placing a notice on
                            <a href="https://www.deepcontrast.com">www.deepcontrast.com</a>
                            or by sending you a notice to the e-mail address that we have on file for you, or by placing a notice in the Service.
                        </p>

                        <h4>9) Your California Privacy Rights</h4>

                        <p>We do not share personal information with third parties for their direct marketing purposes, unless you affirmatively agree
                            to such disclosure.
                            Users in certain jurisdictions have a right to access personal information held about themselves. Your right of access can
                            be exercised in
                            accordance with applicable law. Please submit any requests for access to your personal data in writing to
                            <a href="mailto:privacy@deepcontrast.com">privacy@deepcontrast.com</a>.</p>

                        <h4>10) How to Contact Us</h4>

                        <p>If you have any questions, comments or concerns regarding our Privacy Policy and/or practices, please send an e-mail to
                            <a href="mailto:privacy@deepcontrast.com">privacy@deepcontrast.com</a>. </p>

                    </div>
                </div>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/PrivacyPolicy.js